import { io, type Socket } from 'socket.io-client';
import { getApiUrl } from '@shared/config/env';

interface NotificationSocketLifecycle {
  onConnect: () => void;
  onDisconnect: () => void;
}

// El socket vive en el origen del backend, no bajo el prefijo de la API. Se recorta la ruta
// completa en vez de sustituir `/api`: con la base `/api/v1` esa sustitución dejaba `/v1`.
const SOCKET_URL = deriveSocketOrigin(getApiUrl());

function deriveSocketOrigin(apiUrl: string): string {
  if (apiUrl.startsWith('/')) return '';
  try {
    return new URL(apiUrl).origin;
  } catch {
    return '';
  }
}

export function createNotificationSocket(
  token: string,
  lifecycle?: NotificationSocketLifecycle
): Socket {
  const socket = io(SOCKET_URL || undefined, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 2000,
    reconnectionAttempts: 10,
  });

  socket.on('connect', () => {
    console.log('[Socket.io] Connected:', socket.id);
    lifecycle?.onConnect();
  });

  socket.on('disconnect', (reason) => {
    console.log('[Socket.io] Disconnected:', reason);
    lifecycle?.onDisconnect();
  });

  socket.on('connect_error', (error) => {
    console.warn('[Socket.io] Connection error:', error.message);
  });

  return socket;
}